export const redeemEn = {};

export const redeemFr = {};
